<template>
    <div class="storefront__widget">
        <div
            v-if="header" 
            class="storefront__widget__header"
        >
            <slot name="header"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script setup>
import { useSlots, computed } from 'vue'

const slots = useSlots()
const header = computed(() => !!slots.header)
</script>